import styled from 'styled-components';
import { colors } from '@/globalStyles';

export const PanelWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: ${props => props.$gridTemplateColumns || 'unset'};
  grid-row-gap: ${props => props.$rowGap || '20px'};
`;

export const CodeDataInput = styled.input`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border: none;
  padding-left: 16px;
  box-sizing: border-box;
  resize: none;
  outline: none;
  font-size: 14px;
  font-family: IBMPlexSans;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #666a6e;
  border: ${props => props.$error ? '1px solid red' : '1px solid transparent'};
  text-align: left;
`;

export const InputErrorWrapper = styled.p`
  padding: 0;
  margin: 0;
  color: red;
`;

export const CodeSelectWrapper = styled.div`
  width: 100%;
  height: 49px;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 24px;
  padding: 0 10px 0 20px;
  cursor: pointer;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  border-radius: 4px;
  color: ${colors.black};
`;

export const ListWrapper = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: 1fr;
  grid-row-gap: 20px;
  align-items: center;
`;

export const ListItem = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-column-gap: 13px;
  align-items: center;
  cursor: pointer;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  height: 50px;
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 10px;
  align-items: center;
  justify-content: center;
  position: -webkit-sticky;
  position: sticky;
  bottom: 10px;
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.1);
`;

export const PanelHeaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 20px 1fr;
  grid-column-gap: 10px;
  align-items: center;
  cursor: pointer;
  padding: 5px 0;
  &:hover {
    * {
      fill: ${colors.primary};
    }
  }
`;

export const PanelHeader = styled.div`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

export const Icon = styled.img`
  width: 30px;
  height: 30px;
`;

export const Icon20 = styled.img`
  width: 20px;
  height: 20px;
`;

export const RowWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: ${props => props.$gridTemplateColumns || '1fr'};
  grid-row-gap: 20px;
  grid-column-gap: 20px;
`;

export const ColWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: ${props => props.$gridTemplateRows || '1fr'};
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  align-items: end;
`;